import React from 'react';
import { useIntl } from 'react-intl';
import { useMediaBreakpoint } from '@americanexpress/consumer-travel-base';
import { OnVisible } from '@americanexpress/data-manager-utils';
import { useReactlytics } from '@americanexpress/reactlytics';
import { Card } from '@americanexpress/dls-react';
import { formatDate } from '../../../utils/abandonCartUtils';
import AbandonHotelIcon from '../AbandonHotelIcon';
import { useAbandonCartData } from '../../../hooks/useContextApiHook';
import { createAnalytics } from '../../../utils/createAnalyticsUtil';
import ContinueButton from '../ContiueButton/ContinueButton';
import DismissButton from '../DismissButton/DimissButton';

const AbandonHotelDesktop = () => {
  const { formatMessage } = useIntl();
  const isXLDesktop = useMediaBreakpoint('xl-up');
  const { track } = useReactlytics();
  const triggerAnalytics = createAnalytics(track, {
    element: 'hp-desktop-AbandonHotel',
    type: 'click',
  });
  const { data: abandonCartData } = useAbandonCartData();
  const { tripStartDate, tripEndDate, hotelProductSelected } = abandonCartData;

  return (
    <div id="abandonHotelDesktop">
      <OnVisible
        analyticsInfo={{
          element: 'hp-desktop-AbandonHotel',
          detail: null,
        }}
      >
        <Card className="container pad-3-lr flex flex-align-items-center dls-deep-blue-bg">
          <div className="pad-1 row dls-deep-blue-bg">
            <div className="flex col-md-9 pad-0-l">
              <div className="flex-inline pad-1-l dls-white flex flex-align-items-center">
                <AbandonHotelIcon />
                <div
                  data-testid="abandon-hotel-desktop-text"
                  style={{
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    width: isXLDesktop ? '80%' : '70%',
                  }}
                >
                  <span style={{ fontWeight: 500 }}>
                    {formatMessage({ id: 'abandonHotel.finish' })}
                  </span>
                  <span>{formatMessage({ id: 'abandonHotel.at' })}</span>
                  <span
                    className="text-capitalize font-weight-medium"
                    style={{ paddingRight: '0.2rem' }}
                  >
                    {hotelProductSelected.toLowerCase()}
                  </span>
                </div>
                <div className="text-nowrap">
                  {formatMessage({ id: 'abandonHotel.for' })}
                  <span className="text-nowrap" style={{ fontWeight: 500 }}>
                    {`${formatDate(tripStartDate)} - ${formatDate(tripEndDate)}`}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-3 pad-0">
              <div className="flex flex-justify-end">
                <ContinueButton
                  triggerAnalytics={triggerAnalytics}
                  buttonTextLocaleId="abandonHotel.continue"
                />
                <DismissButton triggerAnalytics={triggerAnalytics} />
              </div>
            </div>
          </div>
        </Card>
      </OnVisible>
    </div>
  );
};

export default AbandonHotelDesktop;
